import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { legalDocumentApi } from "../../../api/legalDocumentApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { ILegalGroup } from '../../../models/response/legal-document/ILegalGroup';
import { eLegalDocuemntActionTypeIds } from '../../action-types/legal-document/ILegalDocumentActionTypes';
import { ILegalGroupActionTypes } from '../../action-types/legal-document/ILegalGroupActionTypes';
import { actions } from '../../actions/actionsWrapper';

export function* legalDocumentSaga(): any {
    yield takeLatest(eLegalDocuemntActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eLegalDocuemntActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eLegalDocuemntActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ILegalGroupActionTypes): any {
    const res: IBaseResponeModel = yield call(legalDocumentApi.selectAll)

    if (res.is_success) {
        yield put(actions.legalDocument.document.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.legalDocument.document.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: ILegalGroupActionTypes): any {
    const res: IBaseResponeModel = yield call(legalDocumentApi.delete, action.payload as number)

    if (res.is_success) {
        yield put(actions.legalDocument.document.DELETE_SUCESSS(res.data))
    } else {
        yield put(actions.legalDocument.document.DELETE_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: ILegalGroupActionTypes): any {
    const payload = action.payload as ILegalGroup;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(legalDocumentApi.update, payload)
    } else {
        res = yield call(legalDocumentApi.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.legalDocument.document.SAVE_SUCESSS(res.data))
    } else {
        yield put(actions.legalDocument.document.SAVE_ERROR(res.message ?? "Error"))
    }
}

